import { PropsWithChildren } from "react";

import { Audio } from "@aircall/tractor";

import { useBaseStore } from "@/store/store";

export function AudioProvider({ children }: PropsWithChildren<unknown>) {
  const audio = useBaseStore((store) => store.audio);

  return <Audio src={audio?.url || ""}>{children}</Audio>;
}
